var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.8,
    height: 315.8,
    viewBox: "0 0 76.8 315.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4,0L38.4,0C17.2,0,0,17.2,0,38.4v145.8c0,21.2,17.2,38.4,38.4,38.4h0c21.2,0,38.4-17.2,38.4-38.4V38.4 C76.8,17.2,59.6,0,38.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4,238.9L38.4,238.9C17.2,238.9,0,256.1,0,277.3v0c0,21.2,17.2,38.4,38.4,38.4h0c21.2,0,38.4-17.2,38.4-38.4v0 C76.8,256.1,59.6,238.9,38.4,238.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.6c016c1da7e00b15badbd3bf9107dc57.svg";
export { ForwardRef as ReactComponent };